import React, { useState } from 'react';

//components material mui
import { DialogContent, DialogActions, TextField, Button, Typography } from '@mui/material';

//Utilidades
import { useGlobalState } from '../../../Utilidades/useGlobalState';

//components
import { DialogoBoostrap } from '../../ControlUsuario/DialogoPersonalizado/DialogoBoostrap';
import { TituloDialogoBoostrap } from '../../ControlUsuario/DialogoPersonalizado/TituloDialogoBoostrap';

//config
import { MOBILE } from '../config';

//styles
import { StyleHome, StyleHomeHeader } from '../../Tool/Style';

let funcionCargarModal;
let validaCargaModal;

/**
 * 
 * @param {{ deviceIs: 'DESKTOP' | 'MOBILE' | 'TABLET' }} props 
 * @returns 
 */
export const DialogoCodigoVerificacion = ({ deviceIs = "DESKTOP", EjecutarValidarToken, EjecutarObtenerToken, CancelarValidarToken }) => {

    const [codigoVerificacion, setCodigoVerificacion] = useState('');

    const [cargaModalInsertarSolicitud, setCargaModalInsertarSolicitud] = useState(false);
    funcionCargarModal = setCargaModalInsertarSolicitud;
    validaCargaModal = cargaModalInsertarSolicitud;

    const { etiquetas } = useGlobalState();

    const VerificarCodigo = async () => {
        EjecutarValidarToken(codigoVerificacion);
        setCodigoVerificacion('');
    };

    const CerrarLimpiarFormulario = () => {
        setCodigoVerificacion('');
        CancelarValidarToken();
    };

    return (
        <DialogoBoostrap
            fullWidth
            maxWidth='sm'
            onClose={CerrarLimpiarFormulario}
            aria-labelledby="customized-dialog-title"
            open={cargaModalInsertarSolicitud}
        >
            <TituloDialogoBoostrap id="customized-dialog-title" onClose={CerrarLimpiarFormulario}>
                {etiquetas.Home.Et_lblCodigoVerificacion}
            </TituloDialogoBoostrap>
            <DialogContent dividers style={{ backgroundColor: '#FFFFFF' }}>
                <Typography style={{ ...StyleHomeHeader.EstadoText, ...{ color: '#3F425D', fontWeight: 400 } }}>
                    {etiquetas.Home.Et_lblCodigoVerificacionDescripcion}
                </Typography>
                <TextField
                    style={{ marginTop: 20, marginBottom: deviceIs === MOBILE ? 5 : 20 }}
                    name="codigoVerificacion"
                    value={codigoVerificacion}
                    variant="outlined"
                    fullWidth
                    label={etiquetas.Home.Et_lblCodigoVerificacion}
                    onChange={(e) => { setCodigoVerificacion(e.target.value) }}
                    inputProps={{
                        maxLength: 36
                    }}>
                </TextField>
                <DialogActions sx={{ flexWrap: deviceIs === MOBILE ? 'wrap' :'nowrap' }}>
                    <Button  style={{marginBottom: deviceIs === MOBILE ? 10 : 0 }} sx={StyleHome.ButtonText} onClick={EjecutarObtenerToken}>
                        {etiquetas.Home.Et_lblObtenerCodigo}
                    </Button>
                    <Button variant="contained" onClick={CerrarLimpiarFormulario} style={StyleHome.ButtonClean}>
                        {etiquetas.General.Et_tbnCancelar}
                    </Button>
                    <Button variant="contained" onClick={VerificarCodigo} style={StyleHome.ButtonSave}>
                        {etiquetas.General.Et_tbnAceptar}
                    </Button>
                </DialogActions>
            </DialogContent>
        </DialogoBoostrap>
    );
};

export const mostrarDialogoCodigoVerificacion= () => {
    funcionCargarModal(!validaCargaModal);
}